var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('object',{attrs:{"data":_vm.SVGIcon,"type":"image/svg+xml"}},[_c('img',{attrs:{"src":_vm.GIFIcon}})])}
var staticRenderFns = []

export { render, staticRenderFns }